export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function confidenceFromSamples(samples, fullConfidenceAt = 5) {
  return clamp((Number(samples) || 0) / fullConfidenceAt, 0, 1);
}

export function learnedContribution(stat, factor = 10) {
  if (!stat || !Number.isFinite(Number(stat.mean))) return 0;
  const confidence = confidenceFromSamples(stat.samples);
  return Number(stat.mean) * confidence * factor;
}

export function hashString(value = "") {
  let hash = 2166136261;
  const text = String(value);
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function seededUnit(seed, salt = "") {
  let value = (Number(seed) || 0) ^ hashString(salt);
  value = Math.imul(value ^ (value >>> 16), 2246822507);
  value = Math.imul(value ^ (value >>> 13), 3266489909);
  return ((value ^ (value >>> 16)) >>> 0) / 4294967295;
}

export function weightedPick(items, seed, topN = 4) {
  const top = items.slice(0, Math.min(topN, items.length));
  if (!top.length) return null;
  if (top.length === 1) return top[0];

  const minimum = Math.min(...top.map((item) => item.score));
  const weights = top.map((item) => Math.max(1, item.score - minimum + 1));
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  let cursor = seededUnit(seed, "weighted-pick") * total;

  for (let index = 0; index < top.length; index += 1) {
    cursor -= weights[index];
    if (cursor <= 0) return top[index];
  }
  return top[top.length - 1];
}
